import useApi from "../../api/useApi";

const useLocationHistoryService = (standId) => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors, id) => {
    return api(
      'get',
      'user/stand/' + standId + '/location-history/' + id,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => console.error('useLocationHistoryService::userShow', error),
    )
  }

  const userShowCollection = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'user/stand/' + standId + '/location-history',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => console.error('useLocationHistoryService::userShowCollection', error),
    )
  }

  const userStore = (callbackSuccess, callbackValidationErrors, modelId, data) => {
    return api(
      'post',
      'user/stand/' + standId + '/location-history/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => console.error('useLocationHistoryService::userStore', error),
      data,
    )
  }

  const userUpdate = (callbackSuccess, callbackValidationErrors, id, data) => {
    return api(
      'post',
      'user/stand/' + standId + '/location-history/' + id + '/update',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => console.error('useLocationHistoryService::userUpdate', error),
      data,
    )
  }

  const userDelete = (callbackSuccess, callbackValidationErrors, id) => {
    return api(
      'post',
      'user/stand/' + standId + '/location-history/' + id + '/delete',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => console.error('useLocationHistoryService::userDelete', error),
    )
  }

  return {
    objectType: 'location_history',
    userShow,
    userShowCollection,
    userStore,
    userUpdate,
    userDelete,
  }
}

export default useLocationHistoryService
